import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { BulletListElement, BulletList } from 'src/components/bullet-points';
import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { colorSecondary200 } from 'src/styles/colors';
import { spacing1, spacing2, spacing3 } from 'src/styles/spacing';

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing3};
  text-align: center;

  @media (min-width: ${breakpointLargeTablet}) {
    text-align: left;
  }
`;

export const StyledDescription = styled(Typography)`
  text-align: center;

  @media (min-width: ${breakpointLargeTablet}) {
    text-align: left;
  }
`;

export const StyledText = styled(Typography)`
  flex-basis: 50%;
  text-align: right;
`;

export const StyledDescriptionProductName = styled(Typography)`
  font-weight: bold;
`;

export const StyledOrderDetails = styled.div`
  margin: ${spacing3} 0;
  border-bottom: 1px solid ${colorSecondary200};
  padding-bottom: ${spacing3};
`;

export const StyledDetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: ${spacing1} 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledProductTitle = styled(Typography)`
  font-weight: bold;
  text-align: left;
  margin-right: ${spacing2};
`;

export const StyledProductName = styled(Typography)`
  font-weight: bold;
  text-align: right;

  @media (min-width: ${breakpointTablet}) {
    text-align: left;
  }
`;

export const StyledDetailsTitle = styled(StyledProductTitle)`
  flex-basis: 50%;
`;

export const StyledProductsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-between;
`;

export const StyledBulletList = styled(BulletList)`
  margin-top: ${spacing2};
  grid-column: 1 / span 2;

  @media (min-width: ${breakpointTablet}) {
    grid-column: 2 / 2;
  }
`;

export const StyledBulletListElement = styled(BulletListElement)`
  margin-top: ${spacing1};
`;
